import {BotType} from "../../../api/generated"

export enum DisabledField {
    VEHICLE_INFO,
    IDD_URL,
    INTEREST_RATE,
    FINANCE_PROVIDER,
    PCP_APR,
    PCP_RESIDUAL_PERCENTAGE,
    PCP_DEALER_CONTRIBUTION,
    VEHICLE_PRICE_DISCOUNT,
    VEHICLE_CONDITION_DISCOUNT,
    VEHICLE_SERVICE_HISTORY_DISCOUNT,
    TEST_DRIVE_REQUEST,
    RESERVATION,
}

export const ALL_DISABLED_FIELDS = [
    DisabledField.VEHICLE_INFO,
    DisabledField.IDD_URL,
    DisabledField.INTEREST_RATE,
    DisabledField.FINANCE_PROVIDER,
    DisabledField.PCP_APR,
    DisabledField.PCP_RESIDUAL_PERCENTAGE,
    DisabledField.PCP_DEALER_CONTRIBUTION,
    DisabledField.VEHICLE_PRICE_DISCOUNT,
    DisabledField.VEHICLE_CONDITION_DISCOUNT,
    DisabledField.VEHICLE_SERVICE_HISTORY_DISCOUNT,
    DisabledField.TEST_DRIVE_REQUEST,
    DisabledField.RESERVATION
]

export type AssistantPreset = {
    disabledFields: DisabledField[],
}

const getAimeStarterPreset = (): AssistantPreset => {
    return {
        disabledFields: [
            DisabledField.VEHICLE_INFO,
            DisabledField.IDD_URL,
            DisabledField.RESERVATION,
            DisabledField.INTEREST_RATE,
            DisabledField.FINANCE_PROVIDER,
            DisabledField.PCP_APR,
            DisabledField.PCP_RESIDUAL_PERCENTAGE,
            DisabledField.PCP_DEALER_CONTRIBUTION,
            DisabledField.VEHICLE_PRICE_DISCOUNT,
            DisabledField.VEHICLE_CONDITION_DISCOUNT,
            DisabledField.VEHICLE_SERVICE_HISTORY_DISCOUNT,
            DisabledField.TEST_DRIVE_REQUEST
        ]
    }
}

const getAimeBuyPreset = (): AssistantPreset => {
    return {
        disabledFields: [
            DisabledField.VEHICLE_INFO,
            DisabledField.IDD_URL,
            DisabledField.INTEREST_RATE,
            DisabledField.FINANCE_PROVIDER,
            DisabledField.PCP_APR,
            DisabledField.PCP_RESIDUAL_PERCENTAGE,
            DisabledField.PCP_DEALER_CONTRIBUTION,
            DisabledField.TEST_DRIVE_REQUEST,
            DisabledField.RESERVATION
        ]
    }
}

const getAimeStockPreset = (): AssistantPreset => {
    return {
        disabledFields: [
            DisabledField.IDD_URL,
            DisabledField.INTEREST_RATE,
            DisabledField.FINANCE_PROVIDER,
            DisabledField.PCP_APR,
            DisabledField.PCP_RESIDUAL_PERCENTAGE,
            DisabledField.PCP_DEALER_CONTRIBUTION,
            DisabledField.RESERVATION,
            DisabledField.VEHICLE_PRICE_DISCOUNT,
            DisabledField.VEHICLE_CONDITION_DISCOUNT,
            DisabledField.VEHICLE_SERVICE_HISTORY_DISCOUNT
        ]
    }
}

const getAimePxPreset = (): AssistantPreset => {
    return {
        disabledFields: [
            DisabledField.IDD_URL,
            DisabledField.INTEREST_RATE,
            DisabledField.FINANCE_PROVIDER,
            DisabledField.PCP_APR,
            DisabledField.PCP_RESIDUAL_PERCENTAGE,
            DisabledField.PCP_DEALER_CONTRIBUTION,
            DisabledField.RESERVATION,
        ]
    }
}

const getAimeFinancePreset = (): AssistantPreset => {
    return {
        disabledFields: [
            DisabledField.RESERVATION,
        ]
    }
}

const getAimeReservationPreset = (): AssistantPreset => {
    return {
        disabledFields: []
    }
}

const getAimeProPreset = (): AssistantPreset => {
    return {
        disabledFields: [
            DisabledField.INTEREST_RATE
        ]
    }
}

export const assistantPresets: Record<BotType, AssistantPreset> = {
    [BotType.AimeStarter]: getAimeStarterPreset(),
    [BotType.AimeStock]: getAimeStockPreset(),
    [BotType.AimePx]: getAimePxPreset(),
    [BotType.AimeFinance]: getAimeFinancePreset(),
    [BotType.AimeReservation]: getAimeReservationPreset(),
    [BotType.TmcAime]: getAimeProPreset(),
    [BotType.AimeBuy]: getAimeBuyPreset(),
} as Record<BotType, AssistantPreset>

export const getDisabledFields = (botType?: BotType): DisabledField[] => {
    if (botType) {
        return assistantPresets[botType].disabledFields
    } else {
        return ALL_DISABLED_FIELDS
    }
}

export const isFieldDisabled = (field: DisabledField, botType?: BotType): boolean => {
    const disabledFields = getDisabledFields(botType)
    return disabledFields.includes(field)
}
